export default __webpack_public_path__ + "static/media/connecticut.065aa142.jpg";